// @flow
export { default } from './Search';



// WEBPACK FOOTER //
// ./src/containers/search/index.js